/**
 * Scroll handling functionality
 * @module scroll
 */

let lastScrollTop = 0;
const SCROLL_THRESHOLD = 20;

/**
 * Handles window scroll behavior
 */
// Modify your handleScroll function
export function handleScroll() {
  // Don't process scroll events when drawer is open
  if (document.body.classList.contains('drawer-open')) return;

  const st = window.scrollY;
  const body = document.body;

  if (st < (lastScrollTop - SCROLL_THRESHOLD)) {
    // Scrolling up
    body.classList.remove('header-hidden', 'meta-hidden');
    body.classList.add('header-sticky', 'meta-sticky');
  }

  if (st > lastScrollTop) {
    // Scrolling down
    body.classList.add('header-hidden', 'meta-hidden');
    body.classList.remove('header-sticky', 'meta-sticky');
  }

  if (st < 50) {
    // At top
    body.classList.add('header-top');
    body.classList.remove('header-sticky', 'header-hidden', 'meta-sticky', 'meta-hidden');
  }

  if (st > 50) {
    // Scrolled past top
    body.classList.remove('header-top');
  }

  lastScrollTop = st;
}
